export type QueryParamKey = FeeQueryParamKey | PartnerQueryParamKey | DebugQueryParamKey | SharedQueryParamKey | PeQueryParamKey | PaQueryParamKey | IqQueryParamKey | PcQueryParamKey | MeQueryParamKey | CmaQueryParamKey;

export enum FeeQueryParamKey {
	CUSTOM_FEE = 'fee',
	EXCLUDE_FEE = 'excludeFee'
}
export enum PartnerQueryParamKey {
	PARTNER = 'partner',
	MOCK_PARTNER_API = 'mockPartnerApi',
	TEST_PARTNER_FIRM = 'testPartnerFirm'
}
export enum DebugQueryParamKey {
	USE_EXT_PARTNER_BETA = 'useExtPartnerBeta',
	USE_PAS_BETA = 'usePasBeta',
	PAS_MOCK_API = 'mockPasApi',
	MODELS_BROWSE_MOCK_API = 'modelsBrowseMockApi',
	MOCK_COUNTRY = 'mockCountry',
	SHOW_PASTE_DEBUG = 'showPasteDebug',
	MOCK_WEALTH_WEB = 'mockWealthWeb',
	SHOW_EDITOR = 'showEditor',
	BUILD_INFO = 'buildInfo',
	LOG = 'log'
}
export enum SharedQueryParamKey {
	PORTFOLIOS = 'portfolios',
	ENGAGEMENT = 'engagement',
	FEATURE_FLAG = 'featureFlag',

	// Debug
	SHOW_EDITOR = 'showEditor',
	SHOW_TOOLTIP = 'showTooltip',
	DEBUG_WINDOW = 'debugWindow',

	// Preview API override flag
	API_OVERRIDE = 'apiOverride',

	// PAS As Of Date override
	PAS_AS_OF_DATE = 'pasAsOfDate',

	// Preview Flag for PaS APIs
	PAS_PREVIEW = 'pasPreview',

	//Locale based config flag
	LOCALE = 'locale'
}
export enum PaQueryParamKey {
	AC_BENCHMARK = 'acBenchmark',
	TAB = 'tab',
	FRAGMENT = 'fragment',
	ROUTED_FROM = 'routedFrom', // Mainly for APB
	IMPORT_PARTNER_PORTFOLIO_MODE = 'importPartnerPortfolioMode', // Used for identifying whether partner portfolio is newly saved or updated
	PORTFOLIO_IDS_WITH_MISSING_DATA = 'portfolioIdsWithMissingData'
}
export enum PeQueryParamKey {
	HOLDINGS = 'holdings',
	FROM = 'from'
}

export enum IqQueryParamKey {
	WATCHLIST = 'watchlist'
}

export enum PcQueryParamKey {
	CURRENCY = 'currency',
	BENCHMARK_ID = 'benchmarkId'
}
export enum MeQueryParamKey {
	SORT_BY_TRADE_DATE = 'sortByTradeDate',
	USER_FILTER_NAME = 'userFilterName',
	GROUP_ID = 'groupId',
	SELECTED_MODELS_DATA = 'allRequestParams', // using whitelisted queryparam fron CWP
	TRIGGER_SIGN_IN = 'triggerSignIn',
	ROUTED_FROM = 'routedFrom',
	FAMILY_ID = 'familyId',
	SUB_TYPE = 'subType',
	DOWNLOAD_ALL_PDF = 'downloadAllPdf',
	SELECTED_MODEL_IDS = 'selectedModelIds'
}

export enum CmaQueryParamKey {
	STRATEGY = 'strategy',
	GOAL = 'goal',
	TARGET = 'target'
}
